import { Col, Form, Row } from "antd";
import { MazakaForm } from "apps/Common/MazakaForm";
import { MazakaInput } from "apps/Common/MazakaInput";
import { openNotificationWithIcon } from "helpers/OpenNotificationWithIcon";
import useMazakaForm from "hooks/useMazakaForm";
import { FC, useEffect } from "react";
import { addSavedSearch, updateSavedSearch } from "apps/CustomerPanel/Favorite/Pages/Searchs/Services";
import { MazakaSelect } from "apps/Common/MazakaSelect";
import { useSelector } from "react-redux";
import { RootState } from "store/Reducers";
import { useQueryClient } from "react-query";
import endPoints from "apps/CustomerPanel/Favorite/Pages/Searchs/EndPoints"

interface SaveFilterDataProps{
onFinish:any
selectedRecord?:any
}

const SaveFilterData:FC<SaveFilterDataProps> = ({onFinish,selectedRecord}) => {
  const queryClient = useQueryClient();
  const [form] = Form.useForm();
  const {userInfoes} = useSelector((state:RootState)=>state.profile)
  const {filter}= useSelector((state:RootState)=>state.realState)
  const { formActions, mazakaForm } = useMazakaForm(form);
  useEffect(()=>{
    if(selectedRecord)
    {
      const notificationTypeIds = selectedRecord?.notificationTypeSavedSearch.map((item:any)=>item.notificationTypeId)||[]
      form.setFieldsValue(
        {
          name:selectedRecord?.name,
          notificationTypeIds
        }
      )

      
    }


  },[selectedRecord])
  const handleOnFinish = async() => {
    mazakaForm.setLoading()
    let formValues = form.getFieldsValue()
    const data:any = {
      userId:userInfoes.id,
      name:formValues["name"],
      notificationTypeIds:formValues["notificationTypeIds"],
      searchCriteria:JSON.stringify(filter),
      active:true
    }

    try {
      if(selectedRecord)
      {
        data["id"] = selectedRecord.id
        data["searchCriteria"] = selectedRecord?.searchCriteria
        await updateSavedSearch({data})
      }
      else{

        await addSavedSearch(data)
      }
        mazakaForm.setSuccess(2000,()=>"İşlem Başarılı")
        queryClient.resetQueries({
          queryKey: endPoints.getSavedSearchs,
          exact: false,
        });
        onFinish()
    } catch (error:any) {
        openNotificationWithIcon("default",error?.message)
        mazakaForm.setFailed(2000,error?.message)
    }
  };
  const notificationTypeOptions = [
    {
      label:"E-Posta ile bildirim",value:1,
      
    },
    {
      label:"Mobil bildirim",value:2,
    }
  ]
  return (
    <>
      <Col span={24} className="!mt-4">
        <MazakaForm
         submitButtonXPosition="left"
          form={form}
          onFinish={handleOnFinish}
          {...formActions}
        >
          <Row gutter={[0,20]} >

          <MazakaInput 
          rules={[{required:true,message:""}]}
          xs={24} name={"name"} label="Adı" placeholder="Adı"
          
          />
          <MazakaSelect  rules={[{required:true,message:""}]} label="Bildirim Yolları" name={"notificationTypeIds"} placeholder="Bildirim Yolları" xs={24} mode="multiple" options={notificationTypeOptions}  />
          </Row>
        </MazakaForm>
      </Col>
    </>
  );
};

export default SaveFilterData;
